import FounderActionCard from "components/NewCards/FounderActionCard";
import React from "react";


interface Founder {
    INSTITUTE_LEADER_IMAGE?: { selectedImage: string };
    INSTITUTE_LEADER_NAME?: string;
    GENDER?: string;
    INSTITUTE_LEADER_DESIGNATION?: string;
    INSTITUTE_LEADER_QUALIFICATION?: string;
    INSTITUTE_LEADER_EXPERIENCE?: string;
    INSTITUTE_LEADER_MOBILE?: string;
    INSTITUTE_LEADER_EMAIL?: string;
    // Add other properties of your founder object if needed
}

const FoundersPreview = () => {
    const foundersData: Founder[] = JSON.parse(sessionStorage.getItem("founders")) || [];

    if (!foundersData || foundersData.length === 0) {
        return <p className="text-gray-500">No founder information added yet.</p>;
    }

    return (
        <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
            {foundersData.map((founder, index) => (
                <FounderActionCard
                    key={`founder-preview-${index}`}
                    element={founder}
                    isError={false} // Default value for preview
                />
            ))}
        </div>
    );
};

export default FoundersPreview;